import React, { createContext, useContext } from 'react';
import { useFavorites } from '../hooks/useFavorites';
interface FavoritesContextType {
  favorites: string[];
  loading: boolean;
  user: any;
  toggleFavorite: (toolId: string) => Promise<void>;
  isFavorite: (toolId: string) => boolean;
}
const FavoritesContext = createContext<FavoritesContextType | undefined>(undefined);
export function FavoritesProvider({
  children
}: {
  children: ReactNode;
}) {
  const favoritesData = useFavorites();
  return <FavoritesContext.Provider value={favoritesData} data-id="element-655">
      {children}
    </FavoritesContext.Provider>;
}
export function useFavoritesContext() {
  const context = useContext(FavoritesContext);
  if (context === undefined) {
    throw new Error('useFavoritesContext must be used within a FavoritesProvider');
  }
  return context;
}